define('viewModels/privileged/composer/forms/EmbeddedQualityFormEditor',[
  'jquery',
  'lib/knockout',
  'lib/lodash4',
  'lib/bluebird',
  'config',
  'services/toastService',
  'services/localeService',
  'services/navHelper',
  'services/loggingService',
  'services/embeddingService',
  'services/featureToggleService',
  'viewModels/ViewModel',
  'models/composer/forms/FormType',
  'util/getPcAuthToken'
], function (
  $,
  ko,
  _,
  Promise,
  config,
  toastService,
  localeService,
  navHelper,
  loggingService,
  embeddingService,
  featureToggleService,
  ViewModel,
  FormType,
  getPcAuthToken
) {
    'use strict';

    var EmbeddedQualityFormEditorViewModel = ViewModel.extend(
      function EmbeddedQualityFormEditor(formType, formId, scorableId) {
        var self = this;

        var validFormTypes = _.keys(FormType);
        var isValidFormType = _.includes(validFormTypes, formType);
        if (!isValidFormType || (!formId && !scorableId)) {
          loggingService.error('bad argument(s): ' + JSON.stringify(arguments));
        }

        /**
         * logs a failure to build embedded form path
         */
        var logBuildPathFailure = function () {
          loggingService.error.apply(
            loggingService,
            ['failed to build path'].concat(
              Array.prototype.slice.call(arguments)
            )
          );
        };
        
        /**
         * builds a path used to embed the editable form view
         * 
         * @param  {string} formType
         * @param  {string} formId
         * @return {string}
         */
        var pathForFormType = function (formType, formId) {
          var prefix = '/#';
          switch (formType) {
            case FormType.survey:
              return prefix + '/surveyForms/' + formId;
            case FormType.evaluation:
              return prefix + '/evaluationForms/' + formId;
            default:
              logBuildPathFailure({
                formType: formType,
                formId: formId
              });
              return prefix;
          }
        };

        /**
         * builds a path used to embed the scorable form view
         * 
         * @param  {string} formType
         * @param  {string} scorableId
         * @return {string}
         */
        var pathForScorableType = function (formType, scorableId) {
          var prefix = '/#';
          switch (formType) {
            case FormType.survey:
              return prefix + '/surveys/' + scorableId;
            case FormType.evaluation:
              return prefix + '/evaluations/' + scorableId;
            default:
              logBuildPathFailure({
                  formType: formType,
                  scorableId: scorableId
              });
              return prefix;
          }
        };

        //----------------------------------------------------------------------
        // Embedding External EvaluationFormEditor
        //----------------------------------------------------------------------
        
        /**
         * the path to the embedded view. computed once when the EmbeddedQualityFormEditor is instantiated.
         * @type {string}
         */
        self.formUrl = (function () {
          var authTokenKey = 'authToken';

          var hash = scorableId ?
            pathForScorableType(formType, scorableId) :
            pathForFormType(formType, formId);

          var query = '?locale=' + localeService.getAppLocale() + '&' +
            authTokenKey + '=' + encodeURIComponent(JSON.stringify(getPcAuthToken()));
          return config.qualityForms.uri + hash + query;
        })();
        
        /**
         * handler used for showing toast messages
         * @param  {object} data
         */
        var handleToast = function(data) {
          var toastTitle = data.title;
          var toastOpts = {
              bodyMessage: data.body,
              publishOnUserInteraction: data.publishOnUserInteraction,
              delay: data.hideAfter ? data.hideAfter * 1000 : null
          };

          if (!data.body) {
            data.body = data.message;
            embeddingService.sendToastNotification(data);
          } else {
            toastService.notifyMessage(toastTitle, toastOpts);
          }
        };
        
        /**
         * handler for triggering a navigation event
         * @param  {object} data
         */
        var handleNavigation = function(data) {
          return navHelper.navigateTo(data);
        };
        
        /**
         * handler for receiving cross document messages from the iframe
         * @param  {object} crossDocumentMessage
         */
        var receiveMessage = function(crossDocumentMessage) {
          var isMatchingOrigin = window.origin === crossDocumentMessage.origin;
          var isMessageOriginLocalhost = window.origin.indexOf("localhost") !== -1;
          var shouldHandleCrossDocumentMessage = isMatchingOrigin || isMessageOriginLocalhost;
          
          if (shouldHandleCrossDocumentMessage) {
            var type = crossDocumentMessage.data.type;
            var data = crossDocumentMessage.data.data;
            
            switch(type) {
              case 'toast':
                return handleToast(data);
              case 'navigation':
                return handleNavigation(data);
              default:
                return loggingService.debug(
                  'received unrecognized message type', 
                  { 
                    type: type, 
                    data: data 
                  }
                );
            }
          }
        };

        // Listen for iframe messages
        window.addEventListener("message", receiveMessage);

        //----------------------------------------------------------------------
        // End Embedding External EvaluationFormEditor
        //----------------------------------------------------------------------

        //----------------------------------------------------------------------
        // Cleanup / Disposal
        //----------------------------------------------------------------------
        self.onDispose = function () {
          window.removeEventListener("message", receiveMessage);
        };
      }
    );
      return EmbeddedQualityFormEditorViewModel;
  });

